import Alert from '@storeblocks/alert';
import { WrapLgMarginBottom } from 'App/global-style';
import { useFormStatus } from 'Forms/forms.hooks';
import React from 'react';
import { isDefined } from 'Utils/type.utils';
import { CancelReasonAkaTravel } from '../cancelAkaTravelForm.constants';
import {
  getCancelAkaTravelAlertDescription,
  getCancelAkaTravelAlertTitle,
} from '../cancelAkaTravelForm.helpers';
import { CancelAkaTravelFormValues } from '../cancelAkaTravelForm.types';

interface CancelAkaTravelFormAlertsProps {
  formValues: CancelAkaTravelFormValues;
  isSubmitting: boolean;
}

export const CancelAkaTravelFormAlerts = ({
  formValues,
  isSubmitting,
}: CancelAkaTravelFormAlertsProps): React.ReactElement | null => {
  const { cancelReason } = formValues;
  const { submitSuccess } = useFormStatus();

  if (
    !isDefined(cancelReason) ||
    isSubmitting ||
    submitSuccess ||
    cancelReason === CancelReasonAkaTravel.NOT_LONGER_IN_UNION
  ) {
    return null;
  }

  return (
    <WrapLgMarginBottom>
      <Alert
        title={getCancelAkaTravelAlertTitle(cancelReason)}
        description={getCancelAkaTravelAlertDescription(cancelReason)}
      />
    </WrapLgMarginBottom>
  );
};
